import PageHero from '../../components/PageHero';
import { Link } from 'react-router-dom';
import './StaticPage.css';

function HelpCenterPage() {
  return (
    <div className="static-page content-page">
      <PageHero
        title="Help Center"
        subtitle="Find answers and get support"
      />
      <div className="content-container">
        <p>
          Need help using WeddingzVenue? Check our FAQ for quick answers, or contact our team for
          personalised support.
        </p>
        <div className="cta-box">
          <h3>Frequently Asked Questions</h3>
          <p>Browse common questions about enquiries, listings, and account management.</p>
          <Link to="/faq" className="btn-primary">
            View FAQ
          </Link>
        </div>
        <p>
          Can&apos;t find what you need? <Link to="/contact">Contact us</Link> and we&apos;ll get back to you
          as soon as possible.
        </p>
      </div>
    </div>
  );
}

export default HelpCenterPage;
